import { type SxProps, type Theme } from "@mui/material";
import { type SystemStyleObject } from "@mui/system";

export const mergeSx = (
  ...entries: Array<SystemStyleObject<Theme> | SxProps<Theme> | undefined>
): SxProps<Theme> =>
  entries.flatMap((entry) =>
    Array.isArray(entry) ? entry : entry ? [entry as SystemStyleObject<Theme>] : [],
  );
